<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="topbar">
        <div>
          <el-input
              v-model="searchValue"
              placeholder="请输入搜索内容"
              size="small"
              prefix-icon="el-icon-search"
              @keyup.enter.native="search()"
              clearable
          />
          <el-button style="margin-left: 20px" type="primary" size="small" @click="search">搜索</el-button>
        </div>
      </div>
      <el-table
          border
          ref="table"
          :data="tableData"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
          @row-click="toggleTable"
          v-loading="loading"
      >
        <el-table-column label="ID" prop="feedbackId" width="100px" align="center"/>
        <el-table-column
            label="反馈内容"
            prop="feedbackText"
            min-width="200px"
            align="center"
            show-overflow-tooltip
        />
        <el-table-column
            label="提交者"
            prop="name"
            width="200px"
            align="center"
        >
          <template #default="scope">
            <user-info :user="scope.row"></user-info>
          </template>

        </el-table-column>
        <el-table-column
            label="联系方式"
            prop="contactWay"
            width="200px"
            align="center"
        />
        <el-table-column
            label="提交时间"
            prop="createDate"
            width="200px"
            align="center"
        >
          <template #default="scope">
            {{ scope.row.createDate | formatDateTime }}
          </template>
        </el-table-column>


        <!--        <el-table-column-->
        <!--            label="当前状态"-->
        <!--            prop="status"-->
        <!--            width="150px"-->
        <!--            align="center"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-tag-->
        <!--                size="medium"-->
        <!--                :type="scope.row.status == '未回复' ? 'danger' : ''"-->
        <!--            >-->
        <!--              {{ scope.row.status }}-->
        <!--            </el-tag>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="200px" align="center">
          <template #default="scope">
            <el-button type="success" size="small" @click="go2UserFeedbackDetail(scope.row)">详情</el-button>
            <!--            <el-button-->
            <!--                size="small"-->
            <!--                type="primary"-->
            <!--                @click.stop="replyFeedback(scope.$index, scope.row)"-->
            <!--            >-->
            <!--              回复-->
            <!--            </el-button>-->
            <!--            <el-button-->
            <!--                size="small"-->
            <!--                type="danger"-->
            <!--                @click.stop="deleteFeedback(scope.$index, scope.row)"-->
            <!--            >-->
            <!--              删除-->
            <!--            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :total="pageOpt.total" :page-size="pageOpt.pageSize" :current-page="pageOpt.curPage"
                     @current-change="currentPageChange"/>
    </el-card>

    <el-dialog
        title="回复反馈"
        :visible.sync="replyFeedbackDialog"
        width="30%"
        class="replyFeedbackDialog"
    >
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="box">
            <div class="avatar"></div>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="header">
            <div class="name">name</div>
            <div class="time">20.02.02 20:20:20</div>
          </div>
          <div class="content">{{ replyFeedbackDialogContent }}</div>
          <div class="file">
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
          </div>
          <el-input
              v-model="textarea"
              type="textarea"
              :rows="4"
              placeholder="请输入文字"
              style="margin-bottom: 20px"
          />
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="replyFeedbackDialog = false">
          取 消
        </el-button>
        <el-button
            type="primary"
            size="small"
            @click="replyFeedbackDialog = false"
        >
          回 复
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getUserFeedbackList} from "@/api/feedback";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  components: {UserInfo},
  data() {
    return {
      navigationKey: 'userFeedback',

      loading: false,
      searchValue: '',
      dateValue: '',
      pageOpt: {
        curPage: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      textarea: '',
      replyFeedbackDialog: false,
      replyFeedbackDialogContent: ''
    }
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.searchValue = navigationObj.searchValue
    this.pageOpt.curPage = navigationObj.curPage

    this.getUserFeedbackList()
  },
  methods: {
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getUserFeedbackList()
    },
    getUserFeedbackList() {

      setNavigationItemWithObj(this.navigationKey, {
        curPage: this.pageOpt.curPage,
        searchValue: this.searchValue
      })

      this.loading = true;
      const params = {
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize,
      };
      getUserFeedbackList(params).then(res => {
        handleRes(res, () => {
          this.pageOpt.total = res.data.total
          this.tableData = res.data.rows
        })
        this.loading = false;
      })
    },
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getUserFeedbackList()
    },
    /**
     * 展开表格
     */
    toggleTable(row, column, event) {
      this.$refs.table.toggleRowExpansion(row)
    },
    handleSelectionChange() {
    },
    /**
     * 回复反馈
     */
    replyFeedback(index, row) {
      this.replyFeedbackDialogContent = row.content
      this.replyFeedbackDialog = true
    },
    /**
     * 删除反馈
     */
    deleteFeedback(index, row) {
      console.log(index, row)
      this.$confirm('是否删除该反馈', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          })
          .catch(() => {
            this.$message('取消操作')
          })
    },
    go2UserFeedbackDetail(entity) {
      this.$router.push({
        path: "userFeedbackDetail",
        query: {
          feedbackId: entity.feedbackId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  padding: 0 20px;
}

.replyFeedbackDialog {
  .box {
    width: 100%;
    display: flex;
    justify-content: center;

    .avatar {
      width: 40px;
      height: 40px;
      background-color: #99a9bf;
      border-radius: 20px;
    }
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;

    .name {
      color: #99a9bf;
    }

    .time {
      color: #99a9bf;
    }
  }

  .content {
    margin-bottom: 20px;
  }

  .file {
    display: flex;
    flex-wrap: wrap;

    .img {
      width: 90px;
      height: 90px;
      margin: 0 20px 20px 0;
      background-color: #99a9bf;
      border-radius: 4px;
    }
  }
}
</style>
